import { Box, Typography, Stack } from "@mui/material";
import { useCallback, useState } from "react";
import { CropImage } from "~/shared/ui/inputs/cropImage/CropImage";
import { BasicModal } from "~/shared/ui/modals/BasicModal";
import { ICropImageInputModal } from "~/shared/types/types";
import { ICropImageInputProps } from "~/shared/types/types";

const SelectImageModal: React.FC<ICropImageInputModal> = ({
  isOpen,
  handleOpen,
  handleClose,
  title_button,
  title_reset,
  reset,
  children,
  buttonVariant,
  buttonSx,
  buttonLabelSx,
}) => (
  <Stack display="flex" flexDirection="column" justifyContent="space-between">
    <BasicModal
      title_button={title_button}
      open={isOpen}
      title_reset={title_reset}
      reset={reset}
      handleOpen={handleOpen}
      handleClose={handleClose}
      buttonVariant={buttonVariant}
      buttonSx={buttonSx}
      buttonLabelSx={buttonLabelSx}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        maxHeight: '80vh',
        overflowY: 'auto',
        overflowX: 'hidden',
      }}>
        <Typography variant="h4" component="h4" textAlign="center" pb={2}>
          Выберите изображение
        </Typography>
        {children}
      </Box>
    </BasicModal>
  </Stack>
);

export const CropImageInput = ({ name, titleButton, title_reset, reset, title, onChange, onNameChange, children, buttonVariant, buttonSx, buttonLabelSx, aspect }: ICropImageInputProps) => {

  const [uiState, setUiState] = useState({
    openSchedule: false,
    openCreateTemplate: false,
    openImage: false,
    isLogoOpen: false,
    visible: false,
    headlineError: false,
    descriptionError: false,
  });
  // Обработчики модальных окон
  const toggleModal = useCallback((key: keyof typeof uiState) => {
    setUiState(prev => ({ ...prev, [key]: !prev[key] }));
  }, []);

  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      {(title || name) && (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          {title ? (
            <Typography variant="h6" component="h6" sx={{ fontSize: '14px' }}>
              {title}:
            </Typography>
          ) : (
            <Box />
          )}
          {name ? <Typography variant="body2">{name}</Typography> : null}
        </Stack>
      )}
      <SelectImageModal
        isOpen={uiState.isLogoOpen}
        handleOpen={() => toggleModal('isLogoOpen')}
        handleClose={() => toggleModal('isLogoOpen')}
        title_button={titleButton}
        title_reset={title_reset}
        reset={reset}
        buttonVariant={buttonVariant}
        buttonSx={buttonSx}
        buttonLabelSx={buttonLabelSx}>
        <CropImage
          title="Применить"
          onChange={onChange}
          handleClose={() => toggleModal('isLogoOpen')}
          onNameChange={onNameChange}
          aspect={aspect} />
      </SelectImageModal>
      {children}
    </Box>
  );
}
